export default "query {\n  getLoginUserInfo {\n\t\t_ALL_\n\t}\n}";